import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { FadeIn } from "../components/Reveal";

export default function NotesWelcome() {
  useEffect(() => { document.title = "Welcome to Notes from Il Salotto · Marella Bolognesi"; }, []);

  return (
    <div data-testid="notes-welcome-page" className="pt-20 min-h-screen">
      <section className="mx-auto max-w-[1000px] px-6 lg:px-12 py-24 lg:py-36 text-center">
        <FadeIn>
          <div className="mx-auto w-14 h-14 border border-ink flex items-center justify-center"><Check size={26} strokeWidth={1.4} /></div>
          <p className="mt-8 text-[11px] uppercase tracking-ultra text-accent">Notes from Il Salotto</p>
          <h1 className="mt-6 font-serif font-light text-5xl lg:text-7xl text-ink tracking-tight leading-[1.0]">
            You're on the list.
          </h1>
          <p className="mt-8 text-lg font-light text-ink-soft leading-relaxed max-w-xl mx-auto">
            Thank you. From time to time I'll write to you about Estate Management, private service and the standards, tools and lessons drawn from inside the profession.
          </p>
        </FadeIn>

        <FadeIn delay={0.12}>
          <div className="mt-16 border-t border-line pt-16 max-w-2xl mx-auto">
            <p className="text-[11px] uppercase tracking-ultra text-accent">While you're here</p>
            <p className="mt-6 font-serif font-light text-2xl lg:text-3xl text-ink leading-[1.35]">
              Il Salotto Digitale is where I share the courses, guides and tools created from the work itself.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <Link to="/salotto-digitale" data-testid="welcome-salotto" className="group bg-ink text-bg px-8 py-4 text-[11px] uppercase tracking-[0.2em] hover:bg-[#33312E] transition-colors flex items-center gap-3">
                Enter Il Salotto Digitale <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link to="/blog" data-testid="welcome-journal" className="border border-ink text-ink px-8 py-4 text-[11px] uppercase tracking-[0.2em] hover:bg-ink hover:text-bg transition-colors">
                Read the Journal
              </Link>
            </div>
          </div>
        </FadeIn>
      </section>
    </div>
  );
}
